<template>
  <div class="mobileDocDetail">
    <div class="browser_warp"
         @click="maskShow=false"
         v-show="maskShow">
      <div class="browser_bg"></div>
      <div class="open_browser_tips">
        <img src="/static/img/link_c.png" />
      </div>
    </div>
    <header class="title">
      <span>课程详情</span>
    </header>
    <main>
      <div class="book-info">
        <img class="book-img"
             :src="dataForm.url?dataForm.url:dataForm.imgurl" />
        <div class="book-mes">
          <div class="book-price">
            <div class="yang">¥</div>
            <div class="first">{{dataForm.currentPrice}}</div>
            <!-- <div class="second">.</div>
            <div class="third">00</div>-->
          </div>
          <div class="mesg">
            <div class="bookmes">
              <div class="one">
                <p class="oo">{{dataForm.bookName}}</p>
                <p class="tt">课程有效期：从购买之日起{{dataForm.loseTime}}天</p>
              </div>
              <div class="two">
                <img class="imgt"
                     src="static\mobileImg\share.png" />
                <p class="share">分享</p>
              </div>
            </div>
            <div class="three">
              <div class="aa">购买数</div>
              <div class="bb">{{dataForm.salesVolumes?dataForm.salesVolumes:0}}</div>
              <div class="cc">
                <p class="dd">次</p>
              </div>
              <!-- <div class="aa">实体书</div>
                       <div class="bb">2</div>
              <div class="cc"><p class="dd">本</p></div>-->
              <div class="aa">浏览数</div>
              <div class="bb">{{dataForm.viewCount}}</div>
              <div class="ee">
                <p class="dd">次</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="one-title">
        <div class="commodity"
             @click="handleIndex(0)">图书简介</div>
        <div class="details"
             @click="handleIndex(1)">图书评论</div>
      </div>
      <div class="lineAll">
        <div v-if="showLine1"
             class="line-1"></div>
        <div v-if="showLine2"
             class="line-2"></div>
      </div>
      <div class="book-show">
        <div class="show-content">
          <!-- 图书简介 -->
          <div class="book-introduce"
               id="toIntroduce"
               v-if="commodity">
            <h6>
              <span>图书简介</span>
            </h6>
            <div class="book-con">
              <div>{{dataForm.bookIntroduction}}</div>
              <div v-for="(data,index) in dataForm.bookChapterList"
                   :key="data.id">
                <h4 class="book-con-title">第{{index+1}}章 {{data.name}}</h4>
                <p class="book-detail"
                   v-for="item in data.subList"
                   :key="item.id">{{item.name}}</p>
              </div>
            </div>
          </div>
          <!-- 图书评论 -->
          <div class="book-comment"
               id="toComment"
               v-if="details">
            <h6>
              <span>图书评论</span>
            </h6>
            <div class="comment-info">
              <div class="comment-list">
                <ul>
                  <li class="comment-list-info"
                      v-for="(data,index) in dataForm.bookCommentList"
                      :key="data.id">
                    <div class="comment-ava">
                      <img :src="data.userAvatarURL?data.userAvatarURL:imgUrl" />
                    </div>
                    <div class="comment-right">
                      <div class="well">
                        <div class="person">{{data.userNickname}}</div>
                        <div class="ping">评论课程：</div>
                        <div class="good">
                          <!-- <div class="commentShow" title="评论" @click="handleClick(data.id,index)">
                          <img class="commentImg" title="评论" src="static\mobileImg\message.png" />
                           <span style="float:left;margin-left:5px">{{data.replyCount}}</span>
                          </div>-->
                          <div class="praiseShow"
                               title="赞一下"
                               @click="handleZan(data.id,4)">
                            <span style="float:left; font-size:0.26rem; color:#999999;">{{data.praiseCount}}</span>
                            <img class="praiseImg"
                                 title="赞一下"
                                 src="static\mobileImg\supportBig.png" />
                          </div>
                        </div>
                      </div>
                      <div class="com-cont">{{data.content}}</div>
                      <div>
                        <div class="time color-999">{{data.createTime}}</div>
                        <div class="goodh">
                          <div class="commentShow"
                               title="评论"
                               @click="handleClick(data.id,index)">回复</div>
                        </div>
                      </div>
                      <!-- 评论回复显示评论的回答 -->
                      <div class="comment-all-reply"
                           v-show="data.showContent && data.commentVos.length">
                        <ul>
                          <li v-for="item in data.commentVos"
                              :key="item.id">
                            <div class="comment-ava new-img">
                              <img :src="item.userAvatarURL?item.userAvatarURL:imgUrl" />
                            </div>
                            <div class="com-reply">
                              <div class="second-reply">{{item.userNickname}}</div>
                              <div class="com-good"
                                   title="赞一下"
                                   @click="handleZan(item.id,4)">
                                <span style="display:inline; float:left;">{{item.praiseCount}}</span>
                                <img class="praiseImg"
                                     src="static\mobileImg\supportBig.png" />
                              </div>
                              <div class="com-contt">{{item.content}}</div>
                              <div class="color-999">{{item.createTime}}</div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <footer>
      <div class="buy"
           @click="jump">加入购物车</div>
      <div class="buy"
           @click="jump">立即购买</div>
    </footer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      maskShow: false,
      commodity: true,
      details: false,
      showLine1: true,
      showLine2: false,
      tableStatus: true,
      dataForm: {
        id: '',
        url: '',
        imgurl: '../../../../../static/img/占位图_en.png',
        bookName: '',
        author: '',
        loseTime: '',
        currentPrice: '',
        bookPrice: '',
        salesVolumes: '',
        bookChapterList: [],
        bookCommentList: [],
        myreply: '',
        myCommentReply: '',
        commentId: null,
        subCommentList: [],
        bookLogoOssId: '',
        bookType: '' // 实体书 电子书
      },
      imgUrl: '../../../../../static/img/avatar-boy.gif',
      pageIndex: 1,
      pageSize: 10,
      totalData: 0,
      which: '',
      SubId: '',
      currentIndex: 0,
      butLoading: false
    }
  },
  computed: {
    bookId () {
      return this.$route.query.id
    }
  },
  created () {
    if (this.bookId) {
      this.getBookInfo()
      this.getBookComment()
      this.openApp()
    }
  },
  mounted () {
    if (this.bookId) {
      this.getBookInfo()
      this.getBookComment()
    }
  },
  methods: {
    handleIndex (index) {
      this.currentIndex = index
      if (index === 1) {
        this.commodity = false
        this.details = true
        this.showLine1 = false
        this.showLine2 = true
        // var comment = document.getElementById("toComment");
        // document.documentElement.scrollTop = comment.offsetTop
      } else {
        this.commodity = true
        this.details = false
        this.showLine1 = true
        this.showLine2 = false
        // var introduce = document.getElementById("toIntroduce");
        // document.documentElement.scrollTop = introduce.offsetTop
      }
    },
    getBookInfo () {
      this.$http
        .get(
          `${window.SITE_CONFIG['trainURL']}/book/trainbook/info/${this.bookId}`
        )
        .then(data => {
          // console.log(data)
          if (data.result.code === 0) {
            this.dataForm.bookName = data.result.data.bookName
            this.dataForm.author = data.result.data.bookWriter
            this.dataForm.loseTime = data.result.data.loseTime
            this.dataForm.currentPrice = data.result.data.currentPrice
            this.dataForm.bookPrice = data.result.data.bookPrice
            this.dataForm.viewCount = data.result.data.viewCount
            this.dataForm.salesVolumes = data.result.data.salesVolumes
            this.dataForm.bookIntroduction = decodeURIComponent(
              data.result.data.bookIntroduction
            )
            this.dataForm.bookChapterList = data.result.data.bookChapterList
            this.dataForm.bookType = data.result.data.bookType
            this.dataForm.id = data.result.data.id
            this.dataForm.url = data.result.data.url
            this.dataForm.bookLogoOssId = data.result.data.bookLogoOssId
            if (data.result.data.bookLogoOssId) {
              this.getUrl(data.result.data.bookLogoOssId)
            }
          }
        })
    },
    // 获取url
    getUrl (id) {
      this.$http.get(`/front/fileupload/alioss/showAliOssSvg/` + id)
        .then(data => {
          if (data.data.code === 0 && data.data.svgList[0]) {
            this.dataForm.url = data.result.svgList[0]
          }
        })
    },
    // 评论列表
    getBookComment () {
      this.$http
        .post(
          `/front/train/trainComment/listBookCommentsAtDetailPage`,
          {
            page: this.pageIndex,
            limit: this.pageSize,
            id: this.bookId
          }
        )
        .then(data => {
          if (data.data.code === 0) {
            this.dataForm.bookCommentList = data.data.data.data
            this.totalData = data.data.data.count
            this.dataForm.bookCommentList.forEach(item => {
              item.showContent = false
            })
            this.$nextTick(() => {
              this.$set(this.dataForm.bookCommentList, this.which, {
                ...this.dataForm.bookCommentList[this.which],
                showContent: true
              })
            })
          }
        })
    },
    // 展示评论框
    handleClick (id, index) {
      var show = !this.dataForm.bookCommentList[index].showContent
      this.$set(this.dataForm.bookCommentList, index, {
        ...this.dataForm.bookCommentList[index],
        showContent: show
      })
    },
    // 取消
    handleCancel (index) {
      this.$set(this.dataForm.bookCommentList, index, {
        ...this.dataForm.bookCommentList[index],
        showContent: false
      })
    },
    // 点赞
    handleZan (id, type) {
      this.$http
        .post(`/front/train/trainPraise/save`, {
          targetId: id,
          type: type
        })
        .then(data => {
          if (data.data.code === 0) {
            this.$message({
              message: '点赞成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getBookInfo()
                this.getBookComment()
              }
            })
          } else {
            this.$message.error(data.data.msg)
          }
        })
    },
    jumpDownload () {
      let { isAndroid, isIOS, isIOS9 } = this.detectVersion()
      if (isAndroid) {
        window.location = window.SITE_CONFIG['androidUrl']
      } else if (isIOS || isIOS9) {
        window.location = window.SITE_CONFIG['iosUrl']
      }
      // this.$router.push('/apkDownload')
    },
    jump () {
      let isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      if (isWx) {
        this.maskShow = true
      } else {
        this.jumpDownload()
        // this.openApp('', this.jumpDownload)
      }
    },
    detectVersion () {
      let isAndroid = false
      let isIOS = false
      let isIOS9
      let version
      let u = navigator.userAgent
      let ua = u.toLowerCase()
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // android终端或者uc浏览器
        // Android系统
        isAndroid = true
      }
      if (ua.indexOf('like mac os x') > 0) {
        // ios
        // let regStr_saf = /os [\d._]*/gi ;
        let verinfo = ua.match(/os [\d._]*/gi)
        version = (verinfo + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')
      }
      let versionStr = version + ''
      if (versionStr !== 'undefined' && versionStr.length > 0) {
        version = parseInt(version)
        if (version >= 8) {
          // ios9以上
          isIOS9 = true
        } else {
          isIOS = true
        }
      }
      return { isAndroid, isIOS, isIOS9 }
    },
    // 判断手机上是否安装了app，如果安装直接打开url，如果没安装，执行callback
    openApp (url, callback = this.jumpDownload) {
      let isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      if (isWx) {
        return false
      }
      let { isAndroid, isIOS, isIOS9 } = this.detectVersion()
      let json = {
        id: this.bookId,
        userId: this.$route.query.userId
      }
      if (isAndroid || isIOS) {
        // let t = 4000
        // let hasApp = true
        // setTimeout(function () {
        //   if (!hasApp) {
        //     callback && callback()
        //   }
        //   document.body.removeChild(ifr)
        // }, 5000)
        // var t1 = Date.now()
        var ifr = document.createElement('iframe')
        if (isAndroid) {
          ifr.setAttribute('src', `${window.SITE_CONFIG['androidAppUrl']}?type=bookDetail&id=${this.bookId}&userId=${this.$route.query.userId}`)
        } else if (isIOS) {
          ifr.setAttribute('src', `${window.SITE_CONFIG['iosAppUrl']}bookDetail?json=${encodeURIComponent(JSON.stringify(json))}`)
        }
        // ifr.setAttribute('src', url)
        ifr.setAttribute('style', 'display:none')
        document.body.appendChild(ifr)

        // setTimeout(function () {
        //   var t2 = Date.now()
        //   if (t2 - t1 < t + 100) {
        //       hasApp = false;
        //   }
        // }, t);
      }
      if (isIOS9) {
        location.href = `${window.SITE_CONFIG['iosAppUrl']}bookDetail?json=${encodeURIComponent(JSON.stringify(json))}`
        // setTimeout(function() {
        //     callback && callback()
        // }, 250);
        // setTimeout(function() {
        //     location.reload();
        // }, 1000);
      }
    }
  }
}
</script>

<style scoped>
.mobileDocDetail {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.browser_warp {
  display: block;
}
.browser_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #000;
  opacity: 0.8;
  z-index: 999;
}
.open_browser_tips {
  position: fixed;
  width: 100%;
  top: 0;
  right: 0;
  z-index: 9999;
}
.open_browser_tips img {
  width: 100%;
  border: 0;
  margin: 0;
  padding: 0;
}
main {
  flex: 1;
  overflow-y: auto;
}
.title {
  height: 0.88rem;
  font-size: 0.36rem;
  line-height: 0.88rem;
  text-align: center;
  border-bottom: 0.01rem solid #eeeeee;
  background: #fff;
}
.title i {
  float: left;
  font-size: 0.52rem;
  padding-left: 0.22rem;
  padding-top: 0.16rem;
}
.title span {
  margin-left: -0.72rem;
  color: #333333;
  letter-spacing: 0;
  font-family: PingFangSC-Medium;
  font-weight: 600;
}
footer {
  height: 0.88rem;
  display: flex;
  /* padding: 0 0.32rem;
  padding-top: 0.16rem; */
  border-top: 0.01rem solid #eeeeee;
}
.buy {
  width: 3.75rem;
  height: 0.88rem;
  background: #ffffff;
  background-color: #ffffff;
  border-right: 0.01rem solid #eeeeee;
  /* padding-left: 1.08rem; */
  padding-top: 0.22rem;
  color: #1b6bb4;
  font-family: PingFangSC-Regular;
  font-size: 0.32rem;
  letter-spacing: 0;
  text-align: center;
  font-weight: bold;
}
footer :hover {
  background-color: #1b6bb4;
  color: #ffffff;
}
/* footer img{
  width: 0.43rem;
} */
.book-info {
  width: 7.5rem;
  min-height: 8.05rem;
  background: #fff;
}
.book-img {
  height: 5rem;
  width: 7.5rem;
}
.book-mes {
  width: 7.5rem;
  height: 3.05rem;
}
.book-price {
  margin-top: 0.2rem;
  height: 0.73rem;
  margin-bottom: 0.14rem;
}
.yang {
  width: 0.22rem;
  height: 0.5rem;
  margin-left: 0.32rem;
  margin-right: 0.05rem;
  color: #ec280b;
  font-size: 0.36rem;
  display: inline;
  font-weight: bold;
}
.first {
  min-width: 0.53rem;
  height: 0.73rem;
  /* margin-left: 0.32rem; */
  /* margin-right: 0.05rem; */
  color: #ec280b;
  font-size: 0.52rem;
  display: inline;
  font-weight: bold;
}
.second {
  width: 0.05rem;
  height: 0.05rem;
  color: #ec280b;
  display: inline;
  font-weight: bold;
}
.third {
  min-width: 0.41rem;
  height: 0.48rem;
  color: #ec280b;
  font-size: 0.34rem;
  display: inline;
  font-weight: bold;
}
.mesg {
  width: 7.5rem;
  min-height: 0.98rem;
  margin-bottom: 0.3rem;
}
.bookmes {
  width: 7.5rem;
  min-height: 0.98rem;
}
.one {
  width: 4.6rem;
  margin-left: 0.32rem;
  float: left;
  display: inline;
}
.two {
  width: 1.32rem;
  height: 0.5rem;
  display: inline;
  float: right;
  background-color: #eeeeee;
  margin-top: 0.24rem;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.oo {
  width: 4.6rem;
  font-size: 0.3rem;
  color: #333333;
  font-weight: bold;
}
.tt {
  width: 4.11rem;
  font-size: 0.28rem;
  color: #999999;
}
.imgt {
  width: 0.238rem;
  height: 0.227rem;
  margin-top: 0.13rem;
  margin-bottom: 0.14rem;
  margin-left: 0.22rem;
  margin-right: 0.11rem;
  display: inline;
}
.share {
  width: 0.57rem;
  height: 0.4rem;
  margin-top: 0.05rem;
  margin-bottom: 0.05rem;
  /* margin-left: 0.22rem; */
  margin-right: 0.19rem;
  font-size: 0.28rem;
  display: inline;
}
.three {
  margin-top: 0.3rem;
}
.aa {
  height: 0.4rem;
  width: 0.85rem;
  font-size: 0.28rem;
  color: #999999;
  margin-right: 0.1rem;
  margin-left: 0.32rem;
  display: inline;
}
.bb {
  height: 0.4rem;
  min-width: 0.17rem;
  font-size: 0.28rem;
  color: #1b6bb4;
  margin-right: 0.1rem;
  display: inline;
}
.cc {
  height: 0.33rem;
  width: 0.33rem;
  /* font-size: 0.28rem; */
  background-color: rgb(218, 228, 238);
  /* margin-right: 0.1rem; */
  display: inline;
  border-radius: 50%;
}
.ee {
  height: 0.33rem;
  width: 0.33rem;
  background-color: rgb(210, 225, 240);
  display: inline;
  border-radius: 50%;
}
.dd {
  height: 0.25rem;
  width: 0.33rem;
  color: #1b6bb4;
  display: inline;
  font-size: 0.24rem;
}
.all-icon {
  float: left;
}
.book-show {
  width: 7.5rem;
  min-height: 5.3rem;
  background: #fff;
  padding: 0.22rem 0.32rem 0.3rem 0.32rem;
  margin-top: 0.2rem;
  /* padding-top: 0.22rem; */
}
.show-title {
  margin: 0.2rem 0;
  border-bottom: 0.01rem solid #e2e2e2;
}
.show-content {
  /* padding-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
  min-height:648px; */
  background: #fff;
  min-height: 5.08rem;
}
.shop {
  width: 300px;
  float: left;
}
/* // 图书简介 */
.show-title-list {
  background: #f8f8f8;
  border-bottom: 0.01rem solid #1d65a8;
  height: 1.03rem;
}
.show-title-list li {
  float: left;
  width: 1.28rem;
  height: 1.03rem;
  line-height: 1.03rem;
  text-align: center;
  cursor: pointer;
}
.show-checked {
  background: #1d65a8;
  color: #fff;
}
.book-introduce {
  width: 7.18rem;
  min-height: 5.08rem;
}
.book-introduce h6 {
  font-weight: normal;
  margin-bottom: 0.3rem;
}
.book-introduce span {
  border-left: 0.05rem solid #1b6bb4;
  color: #333;
  font-size: 0.36rem;
  display: inline-block;
  line-height: 0.33rem;
  padding-left: 0.18rem;
  font-weight: bold;
  font-family: PingFangSC-Medium;
}
.book-con {
  width: 6.19rem;
  font-size: 0.28rem;
}
.book-one {
  width: 6.19rem;
  font-size: 0.28rem;
}
.book-detail {
  margin-top: 0.18rem;
  margin-bottom: 0.3rem;
  color: #666666;
  width: 6.19rem;
  font-size: 0.28rem;
}
.table-list {
  width: 50%;
  height: 135px;
}
.table-more-list {
  width: 50%;
}
.book-comment {
  width: 7.18rem;
  min-height: 5.08rem;
}
.book-comment h6 {
  font-weight: normal;
  margin-bottom: 0.3rem;
}
.book-comment h6 span {
  border-left: 0.05rem solid #1b6bb4;
  color: #333;
  font-size: 0.36rem;
  display: inline-block;
  line-height: 0.33rem;
  padding-left: 0.18rem;
  font-weight: bold;
  font-family: PingFangSC-Medium;
}
.comment-info {
  margin-top: 0.3rem;
}
/* // 评论 */
.comment-list ul ::after {
  content: "";
  clear: both;
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
.comment-input {
  height: 170px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #ccc;
  margin-bottom: 30px;
}
.comment-ava {
  width: 0.84rem;
  height: 1.4rem;
  float: left;
  display: inline;
}
.comment-ava img {
  width: 0.84rem;
  height: 0.84rem;
  border-radius: 50%;
}
.comment-right {
  float: right;
  margin-left: 0.2rem;
  width: 5.62rem;
  height: auto;
  background: #fff;
  display: inline;
}
.person {
  min-width: 0.56rem;
  min-height: 0.33rem;
  font-size: 0.28rem;
  display: inline;
  float: left;
  margin-right: 0.2rem;
  color: #333333;
  font-weight: bold;
}
.ping {
  width: 1.2rem;
  height: 0.33rem;
  font-size: 0.24rem;
  color: #666666;
  display: inline;
  float: left;
}
.comment-me {
  float: right;
  margin-top: 20px;
}
.comment-list-info {
  height: auto;
  width: 6.86rem;
  border-bottom: 0.01rem solid #ccc;
  padding: 0.1rem 0;
}
.time {
  float: left;
}
.good {
  float: right;
  min-width: 0.91rem;
  height: 0.33rem;
  /* padding-left: 1.88rem; */
  display: inline;
}
.well {
  height: 0.33rem;
  weight: 5.82rem;
}
.commentImg {
  float: left;
  width: 15px;
  height: 15px;
}
.praiseImg {
  float: right;
  margin-left: 0.12rem;
  width: 0.35rem;
  height: 0.33rem;
  /* margin-right: 0.32rem; */
}
.commentShow {
  float: left;
  width: 0.56rem;
  height: 0.33rem;
  color: #1b6bb4;
  font-size: 0.28rem;
  margin-left: 0.2rem;
}
.praiseShow {
  float: right;
}
.comment-show {
  margin-bottom: 5px;
}
.com-reply {
  float: right;
  width: 4.5rem;
  display: inline;
  margin-left: 0.2rem;
}
.com-good {
  /* min-width: 0.76rem;
  height:0.33rem; */
  float: right;
  font-size: 0.26rem;
  color: #999999;
  /* min-width:0.91rem; */
  height: 0.33rem;
  /* margin-right: 0.32rem; */
  /* padding-top:60px;
  cursor: pointer; */
}
.com-good img {
  width: 0.35rem;
  height: 0.33rem;
}
.com-cont {
  margin-top: 0.16rem;
  margin-bottom: 0.16rem;
  width: 5.6rem;
  font-size: 0.3rem;
  color: #333333;
}
.one-title {
  display: inline-flex;
  width: 7.5rem;
  height: 0.99rem;
  background-color: #ffffff;
  margin-top: 0.2rem;
}
.commodity {
  margin-left: 1.81rem;
  margin-right: 1.33rem;
  color: #333333;
  font-size: 0.32rem;
  margin-top: 0.32rem;
  font-weight: bold;
}
.commodity:hover {
  color: #1b6bb4;
}
.details {
  color: #333333;
  font-size: 0.32rem;
  margin-top: 0.32rem;
  font-weight: bold;
}
.details:hover {
  color: #1b6bb4;
}
.line-1 {
  height: 0.04rem;
  background: #1b6bb4;
  width: 1.24rem;
  margin-left: 1.83rem;
}
.line-2 {
  height: 0.04rem;
  background: #1b6bb4;
  width: 1.24rem;
  margin-left: 4.42rem;
}
.lineAll {
  height: 0.04rem;
  background: #ffffff;
  width: 7.5rem;
}
.book-con-title {
  width: 6.19rem;
  font-size: 0.3rem;
  color: #333333;
  margin-top: 0.3rem;
}
.time color-999 {
  width: 1.24rem;
  height: 0.33rem;
  font-size: 0.22rem;
  color: #999999;
}
.comment-all-reply {
  width: 5.62rem;
  margin-top: 0.31rem;
}
.comment-ava new-img {
  width: 0.64rem;
  height: 0.64rem;
  float: left;
  display: inline;
}
.second-reply {
  height: 0.33rem;
  min-width: 1.12rem;
  display: inline;
  float: left;
}
.com-contt {
  width: 4.5rem;
  font-size: 0.28rem;
  color: #333333;
  margin-top: 0.49rem;
  margin-bottom: 0.16rem;
}
</style>
